import { createSlice } from "@reduxjs/toolkit";

export const feeInvoicePrintPreferencesInitial = {
  school: true,
  student: true,
  template: "template1",
  keepHeaderSpace: false,
  printTheme: "color", // "color" | "bw"
};

export const selectFeeInvoicePrintPreferences = (state) => ({
  ...feeInvoicePrintPreferencesInitial,
  ...(state.commonStore?.feeInvoicePrintPreferences ?? {}),
});

export const selectFeeSettings = (state) => ({
  allowMonthSkipping: false,
  ...(state.commonStore?.feeSettings ?? {}),
});

export const selectAllowMonthSkipping = (state) =>
  Boolean(selectFeeSettings(state).allowMonthSkipping);

export const selectAllowCurrentSessionFeeWithLastYearArrear = (state) =>
  Boolean(selectFeeSettings(state).allowCurrentSessionFeeWithLastYearArrear);

export const selectHasAllowMonthSkipping = (state) => {
  const fs = state.commonStore?.feeSettings;
  return Boolean(
    fs &&
      Object.prototype.hasOwnProperty.call(fs, "allowMonthSkipping"),
  );
};

export const selectHasAllowCurrentSessionFeeWithLastYearArrear = (state) => {
  const fs = state.commonStore?.feeSettings;
  return Boolean(
    fs &&
      Object.prototype.hasOwnProperty.call(
        fs,
        "allowCurrentSessionFeeWithLastYearArrear",
      ),
  );
};

export const commonSlice = createSlice({
  name: "commonSlice",
  initialState: {
    policyExpireTime: "",
    feeInvoicePrintPreferences: feeInvoicePrintPreferencesInitial,
    feeSettings: {
      allowMonthSkipping: false,
    },
  },
  reducers: {
    setPolicyTimeout: (state, { payload }) => {
      state.policyExpireTime = payload;
    },
    setFeeInvoicePrintPreferences: (state, { payload }) => {
      state.feeInvoicePrintPreferences = {
        ...state.feeInvoicePrintPreferences,
        ...payload,
      };
    },
    setFeeSettings: (state, { payload }) => {
      state.feeSettings = {
        ...state.feeSettings,
        ...(payload ?? {}),
      };
    },
  },
});

export default commonSlice.reducer;
export const { setPolicyTimeout, setFeeInvoicePrintPreferences, setFeeSettings } =
  commonSlice.actions;
